// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewSpaceItem_wrapper__2uO6A","container":"NewSpaceItem_container__2cO7B","actions":"NewSpaceItem_actions__1eOU3"};